import React from 'react'
import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import Button from '../../components/shared/Button'

const columnHelper = createColumnHelper()

/**
 * 创建爬虫商品预览表格列定义。
 * @param {{
 *   importing: boolean,
 *   imageEnabled: boolean,
 *   isAllSelected: boolean,
 *   selectableCodes: string[],
 *   selectedCodes: string[],
 *   onToggleAll: () => void,
 *   onToggleCode: (productCode: string) => void,
 *   onImportOne: (productCode: string) => void,
 * }} options 列行为配置
 * @returns {Array<any>} 表格列数组
 */
export const createColumns = (options) => {
  const {
    importing,
    imageEnabled,
    isAllSelected,
    selectableCodes,
    selectedCodes,
    onToggleAll,
    onToggleCode,
    onImportOne,
  } = options

  return [
    columnHelper.accessor('productCode', {
      id: 'select',
      header: () => (
        <input
          type="checkbox"
          checked={isAllSelected}
          disabled={selectableCodes.length <= 0 || importing}
          onChange={onToggleAll}
          className="size-4"
        />
      ),
      cell: (info) => {
        const row = info.row.original
        return (
          <input
          type="checkbox"
          checked={selectedCodes.includes(row.importKey || row.productCode)}
          disabled={row.imported || importing}
          onChange={() => onToggleCode(row.importKey || row.productCode)}
            className="size-4"
          />
        )
      },
    }),
    ...(imageEnabled
      ? [
          columnHelper.accessor('imageUrl', {
            header: 'Image',
            cell: (info) => {
              const imageUrl = info.getValue()
              const name = info.row.original.name

              if (!imageUrl) {
                return <span className="text-sm text-gray-400">No Image</span>
              }

              return (
                <img
                  src={imageUrl}
                  alt={name}
                  className="h-14 w-14 rounded-lg border object-cover"
                />
              )
            },
          }),
        ]
      : []),
    columnHelper.accessor('name', {
      header: 'Product',
      cell: (info) => {
        const row = info.row.original

        return (
          <div className="flex max-w-[260px] flex-col">
            <span className="font-medium">{row.name}</span>
            <span className="text-xs text-gray-500">{row.productCode}</span>
            <span className="text-xs text-gray-500">{row.model}</span>
          </div>
        )
      },
    }),
    columnHelper.accessor('brandName', {
      header: 'Brand',
    }),
    columnHelper.accessor('categoryLabel', {
      header: 'Category',
      cell: (info) => (
        <span className="block max-w-[240px] whitespace-normal">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor('price', {
      header: 'Price',
      cell: (info) => {
        const row = info.row.original
        return `${row.currencySymbol}${Number(info.getValue() || 0).toFixed(4)}`
      },
    }),
    columnHelper.accessor('stockNumber', {
      header: 'Stock',
    }),
    columnHelper.accessor('imported', {
      header: 'Status',
      cell: (info) => {
        const row = info.row.original

        if (!info.getValue()) {
          return <span className="text-amber-600">Pending Import</span>
        }

        return (
          <div className="flex flex-col">
            <span className="text-green-600">Imported</span>
            {row.importedProduct?._id && (
              <NavLink
                to={`/products/view/${row.importedProduct._id}`}
                className="text-xs text-primary underline"
              >
                View Product
              </NavLink>
            )}
          </div>
        )
      },
    }),
    columnHelper.accessor('productCode', {
      id: 'action',
      header: 'Action',
      cell: (info) => {
        const row = info.row.original

        if (row.importedProduct?._id) {
          return (
            <a
              href={row.productUrl}
              target="_blank"
              rel="noreferrer"
              className="text-sm text-primary underline"
            >
              Source
            </a>
          )
        }

        return (
          <div className="flex flex-col items-start gap-2">
            <Button
              onClick={() => onImportOne(row.importKey || row.productCode)}
              disabled={importing}
              className="px-2 py-1 text-sm"
            >
              Quick Import
            </Button>
            <a
              href={row.productUrl}
              target="_blank"
              rel="noreferrer"
              className="text-xs text-primary underline"
            >
              Source
            </a>
          </div>
        )
      },
    }),
  ]
}
